import { CleaveInput, UiBlockingSpinner } from '@cp-shared-19/frontend-ui';
import { useTranslationWithFormatting } from 'localization/useTranslationWithFormatting';
import React, { useEffect, useState } from 'react';
import { IbanStateHandler } from '../types';
import { FormikProps, useFormikContext } from 'formik';
import { InitialValues } from '../InitialValues';
import { useFocusOnMount } from '../../../../../../../../utils/useFocusOnMount';

export type ValidatedIbanInputProps = {
    isValidating: boolean;
    ibanStateHandler: IbanStateHandler;
};

const translationPrefix = 'iban-section.edit.iban';
const cleaveOptionsIban = {
    delimiter: ' ',
    blocks: [4, 4, 4, 4, 4, 4, 4, 4, 4],
    numericOnly: false,
};

export const ValidatedIbanInput: React.FC<ValidatedIbanInputProps> = ({ isValidating, ibanStateHandler }) => {
    const { t } = useTranslationWithFormatting('financial-details');
    const { signedBankData } = ibanStateHandler;
    const { setFieldTouched }: FormikProps<InitialValues> = useFormikContext();
    const [shouldValidate, setShouldValidate] = useState<boolean>(true);

    useEffect(() => {
        if (ibanStateHandler.savedIban.iban && shouldValidate) {
            setFieldTouched('iban', true, shouldValidate);
            setShouldValidate(false);
        }
    }, [shouldValidate, setFieldTouched, ibanStateHandler.savedIban]);

    useFocusOnMount('input[name="iban"]');

    return (
        <UiBlockingSpinner isBlocking={isValidating}>
            <CleaveInput
                requiredText=" *"
                aria-required={true}
                required={true}
                isMandatory={true}
                className="c-form-field--no-floating"
                cleaveOptions={cleaveOptionsIban}
                label={t(`${translationPrefix}.label`)}
                name="iban"
                testId="iban"
                inputId="iban"
                tooltip={t(`${translationPrefix}.tooltip`)}
                autocomplete="iban"
            />
            {signedBankData?.data.isValid && (
                <p className="u-text-success">{signedBankData.data.bankDetails?.bankName}</p>
            )}
        </UiBlockingSpinner>
    );
};
